import { configureStore } from '@reduxjs/toolkit';
import completedStagesReducer from './reducers/completedStages';
export const storeOptions = {
    reducer: {
        completedStages: completedStagesReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
